<ion-tabs>

  
  <ion-tab-bar slot="bottom">
    <ion-tab-button tab="tab1">
      <ion-icon name="home"></ion-icon>
      <ion-label>{{ 'TABS.HOME' | translate }}</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="tab2">
      <ion-icon name="star"></ion-icon>
      <ion-label>{{ 'TABS.CATEGORIAS' | translate }}</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="tab3">
      <ion-icon name="list"></ion-icon>
      <ion-label>{{ 'TABS.ORDENES' | translate }}</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="buscar">
      <ion-icon name="search"></ion-icon>
      <ion-label>{{ 'TABS.BUSCAR' | translate }}</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="sales" *ngIf="_us.usuario.username === 'NDIAZ' || _us.usuario.username === 'VSANGIOVANNI'">
      <ion-icon name="bar-chart-outline"></ion-icon>
      <ion-label>{{ 'TABS.VENTAS' | translate }}</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="visitas" *ngIf="_us.usuario.tipoUsuario !== 'C'">
      <ion-icon name="people-circle-outline"></ion-icon>
      <ion-label>{{ 'TABS.VISITAS' | translate }}</ion-label>
    </ion-tab-button>

    <ion-tab-button tab="ofertas">
      <ion-icon name="flame-outline"></ion-icon>
      <ion-label>{{ 'TABS.OFERTA' | translate }}</ion-label>
    </ion-tab-button>
    
    <!-- <ion-tab-button tab="cobros" *ngIf="_us.usuario.tipoUsuario !== 'C'"> -->
    <ion-tab-button tab="cobros" *ngIf="false">
      <ion-icon name="cash-outline"></ion-icon>
      <ion-label>{{ 'COBROS.TITULO' | translate }}</ion-label>
    </ion-tab-button>

  </ion-tab-bar>

</ion-tabs>


  <!-- <ion-fab slot="fixed" vertical="bottom" horizontal="end">
    <ion-fab-button>
      <ion-icon name="chevron-up-circle"></ion-icon>
    </ion-fab-button>
    <ion-fab-list side="top">
      <ion-fab-button>
        <ion-icon name="document"></ion-icon>
      </ion-fab-button>
      <ion-fab-button>
        <ion-icon name="color-palette"></ion-icon>
      </ion-fab-button>
      <ion-fab-button>
        <ion-icon name="globe"></ion-icon>
      </ion-fab-button>
    </ion-fab-list>
  </ion-fab> -->



